"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPhoneNumberForInternal = exports.transformPhoneNumberForEntrata = void 0;
var libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
var transformPhoneNumberForEntrata = function (phoneNumber, countryCode) {
    if (countryCode === void 0) { countryCode = 'US'; }
    if (!phoneNumber)
        return '';
    var cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');
    var phoneNumberObject = (0, libphonenumber_js_1.default)(cleanedNumber, countryCode);
    if (!phoneNumberObject)
        return '';
    var countryCallingCode = phoneNumberObject.countryCallingCode, nationalNumber = phoneNumberObject.nationalNumber;
    return "+".concat(countryCallingCode, " ").concat(nationalNumber);
};
exports.transformPhoneNumberForEntrata = transformPhoneNumberForEntrata;
var transformPhoneNumberForInternal = function (phoneNumber, countryCode) {
    if (countryCode === void 0) { countryCode = 'US'; }
    if (!phoneNumber)
        return '';
    var cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');
    var phoneNumberObject = (0, libphonenumber_js_1.default)(cleanedNumber, countryCode);
    if (!phoneNumberObject)
        return '';
    var number = phoneNumberObject.number;
    return number;
};
exports.transformPhoneNumberForInternal = transformPhoneNumberForInternal;
